import axios from "axios";
import { Row, Skeleton, Typography } from "antd";
import { BLgroup } from "interfaces/internal";
import React, { useEffect, useState } from "react";
import { Member } from "interfaces/users";
import SingleGroup from "./SingleGroup";

const { Title } = Typography;

interface Props {
  blGroups: BLgroup[];
}

const Groups: React.FC<Props> = ({ blGroups }) => {
  const [allActiveMembers, setAllActiveMembers] = useState<Member[]>([]);

  useEffect(() => {
    axios.get<Member[]>(`/internal/active-members/`).then(response => {
      setAllActiveMembers(response.data);
    });
  }, []);

  return (
    <>
      <Title level={4}>Medlemsgrupper</Title>
      {blGroups.length === 0 && <Skeleton active />}
      <Row gutter={[16, 16]}>
        {blGroups.map(group => (
          <SingleGroup key={group.id} group={group} allActiveMembers={allActiveMembers} />
        ))}
      </Row>
    </>
  );
};

export default Groups;
